import {APIService} from '@/services/api.service';
import {RecommendationsContextWithOffers} from '@/views/amex/app-types';
export interface AdditionalPOIDetailsResponse {
  pois: RecommendationsContextWithOffers[];
}

export async function fetchAdditionalPois(ids: string[]): Promise<RecommendationsContextWithOffers[]> {
  try {
    const {pois} = await APIService.post<AdditionalPOIDetailsResponse>(
      `domain/pois`,
      {pois: ids},
      {
        params: {
          mode: process.env.VUE_APP_MODE,
          return_abstract: false,
        },
      },
    );
    // return candidates.map((x) => ({
    //   ...x,
    //   name: x.name.replace(/_/g, ', '),
    //   type: x.category.toLowerCase(),
    //   img: x.image_url,
    // }));
    return pois;
  } catch (e) {
    return [];
  }
}
